import { gql, useLazyQuery } from "@apollo/client";
import { useCallback } from "react";
import type { IdeaBook } from "./types";

const GET_IDEA_BOOK = gql`
  query GetIdeaBook($ideaBookId: ID!) {
    getIdeaBook(ideaBookId: $ideaBookId) {
      _id
      homeownerId
      name
      itemCount
      createdAt
      updatedAt
      coverImage {
        _id
        url
        path
        title
        description
        credit
      }
    }
  }
`;

type GetIdeaBookData = {
  getIdeaBook: IdeaBook | null;
};

type GetIdeaBookVars = {
  ideaBookId: string;
};

export const useGetIdeaBook = () => {
  const [getIdeaBookQuery, { loading, error, data }] = useLazyQuery<
    GetIdeaBookData,
    GetIdeaBookVars
  >(GET_IDEA_BOOK);

  const getIdeaBook = useCallback(
    async (ideaBookId: string, refresh: boolean = false) => {
      const result = await getIdeaBookQuery({
        variables: { ideaBookId },
        fetchPolicy: refresh ? "network-only" : "cache-first",
      });
      return result.data?.getIdeaBook ?? null;
    },
    [getIdeaBookQuery]
  );

  return {
    getIdeaBook,
    loading,
    error,
    ideaBook: data?.getIdeaBook ?? null,
  };
};
